import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { UserService } from "../_services/user.service";
import { Observable } from "rxjs/Rx";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private _router: Router, private _userService: UserService) {
    }

    canActivate(): boolean {
        let ResponseToken = JSON.parse(localStorage.getItem('currentUser'));
        if (ResponseToken === null) {
            this._router.navigate(['/login']);
            return false;
        }
        if (ResponseToken.access_token != '' && ResponseToken.access_token != null) {
            return true;
        } else {
            this._router.navigate(['/login']);
            return false;
        }
    }

    // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    //     let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    //     return this._userService.verify().map(
    //         data => {
    //             if (data !== null) {
    //                 // logged in so return true
    //                 return true;
    //             }
    //             // error when verify so redirect to login page with the return url
    //             this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    //             return false;
    //         },
    //         error => {
    //             // error when verify so redirect to login page with the return url
    //             this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    //             return false;
    //         });
    // }
}


// WEBPACK FOOTER //
// ./src/app/auth/_guards/auth.guard.ts